import styled from "styled-components";
import { COLORS, fontMixins } from "../../../../styles";

export const HeaderContainer = styled.div`
	display: flex;
	align-items: flex-start;
`;

export const LeftSide = styled.div`
	display: flex;
`;

export const RightSide = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	flex: 1;
	margin-top: 26px;
`;

export const ShowTitle = styled.div`
	${fontMixins(12, 400)};
	color: ${COLORS.Black};
	margin-top: 14px;
`;

export const ShowButton = styled.button`
	border: 0;
	${fontMixins(12, 500)};
	color: #c2c2c2;
	background: transparent;
	margin-top: 14px;
`;

export const ManageSubscription = styled.a`
	display: flex;
	color: #5e89db;
	${fontMixins(14, 400)};
	margin-top: 14px;
	margin-left: 21px;
	cursor: pointer;
`;
